import { z } from 'zod';

export const waitTipsSearchSchema = z.object({
  locale: z.string().optional().catch(undefined),
  /** Undefined is "both"; the screen lists retired tips alongside live ones. */
  active: z.enum(['live', 'retired']).optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
});

export type WaitTipsSearch = z.infer<typeof waitTipsSearchSchema>;
